import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { environment } from '../../environments/environment';
import { otpValidation } from '../models/otpValidation.model';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
};

@Injectable({ providedIn: 'root' })
export class ProductService {
  constructor(private http: HttpClient) {}

  getCMSContent(U: string, M: string): Observable<any> {
    const cmscontentURLobj = { url: environment.CMS_HOST + U, method: M };
    return this.http.post(
      `${environment.ECARE_URL}/getEshopHTML.service`,
      cmscontentURLobj,
      httpOptions
    );
  }

  getProductsByCategory(
    L: string,
    iADF: number = 1,
    C: string, //categoryId
    NS: string, //navigationState
    N: string = '0' //index number
  ): Observable<any> {
    const payload = { categoryId: C, navigationState: NS, No: N };
    return this.http.post(
      `${
        environment.BASE_URL
      }/getProductsByCategory?locale=${L}&isApplyDefaultFilters=${
        iADF == 1 ? true : false
      }`,
      payload,
      httpOptions
    );
  }

  getMobileEligibility(accountNo:number): Observable<any> {
    const payload = { accountNumber: accountNo };
    return this.http.post(
      `${environment.ECARE_URL}/cqtGetAccountType.service`,
      payload,
      httpOptions
    );
  }

  generateOTP(accountNo:number):Observable<any>{
    const payload = { "accountNo":accountNo, "notificationType":"SMS", "notificationValue":accountNo };
    return this.http.post(
      `${environment.BASE_URL}/cqtGenerateOtpByAccountNumber`,
      payload,
      httpOptions
    );
  }
  
  validateOTP(otpValidation:otpValidation):Observable<any>{
    return this.http.post(
      `${environment.BASE_URL}/cqtValidateOtpAccountNumber`,
      otpValidation,
      httpOptions
    );
  }

  getAccountType(accountNumber: string):Observable<any>{
    const payload ={"accountNumber":accountNumber};
    return this.http.post(
      `${environment.ECARE_URL}/cqtGetAccountType.service`,
      payload,
      httpOptions
    );
  }

  getCountries(sku: string):Observable<any>{
    return this.http.get(
      `${environment.ESHOP_URL}/getCountries/${sku}`,
      httpOptions
    );
  }

  getAccountSummary(accountNo:string) {
    const payload = { accountNumber: accountNo };
    return this.http.post(
      `${environment.ECARE_URL}/getAccSummary.service`,
      payload,
      httpOptions
    )
  }

}
